import MessageModal from './MessageModal.vue'
import Modal from './Modal.vue'
import SlideIn from './SlideIn.vue'

export const ZenMessageModal = MessageModal
export const ZenModal = Modal
export const ZenSlideIn = SlideIn
